// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".showtext[data-v-9012ed3e] {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  max-width: 75%;\n}\n.grey--text[data-v-9012ed3e] {\n  width: 5%;\n}", ""]);
// Exports
module.exports = exports;
